import { Atto } from '../atto';
import { DocumentoAggregato } from '../documento-aggregato';
import { Sezione } from './sezione';

export class SezioneAttiFull extends Sezione {
  atti: Atto[] = [];
  documentiAggregati: DocumentoAggregato[];
}
